import { useEffect, useState } from "react";

import Modal from "react-bootstrap/Modal";

import { jobService, reviewService } from "services";
import deafultuserImg from "assets/images/avatar.svg";
import useCurrentUser from "hooks/useCurrentUser";
import { Form } from "react-bootstrap";
import { FaStar } from "react-icons/fa";
import { toast } from "react-toastify";
import { Formik, useFormik } from "formik";
import * as Yup from 'yup';


function RatenReview(props) {
  const { show, handleClose, pilotId, jobId, setJobDetails } = props;

  const [data, setData] = useState(false)
  const { user } = useCurrentUser();
  const [isLoading, setIsLoading] = useState(false);
  const [rate, setRate] = useState(0);

  const getReviewList = async () => {
    try {
      const response = await reviewService.getReviewList(pilotId)
      setData(response?.data?.data)
    }
    catch (err) {
      console.log(err?.response?.data?.data)
    }
  }

  const formik = useFormik({
    initialValues: {
      "jobId": jobId,
      "rating": "",
      "description": ""
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      rating: Yup.string().required("Please enter ratings"),
      description: Yup.string().required("Please Enter Description")
    }),
    onSubmit: async (values) => {
     
      try {
        const response = await reviewService.addReview(values)
        if (response?.data?.success === true) {
          const jobResult = await jobService.clientJobDetails(response?.data?.data?.jobId);
          if (response?.data?.success === true) {
            setJobDetails(jobResult?.data?.data)
            setRate(rate)
            toast.success(response?.data?.message)
            handleClose();
          } else {
            toast.error(response?.data?.message)
          }
        }
        else {
          toast.error(response?.data?.message)
        }
      }
      catch (err) {
        console.log(err)
      }
    },
  });
  useEffect(() => {
    getReviewList();
  }, [])

  useEffect(() => {
    const keyDownHandler = event => {
      if (event.key === 'Enter') {
        formik.handleSubmit();
      }
    };

    document.addEventListener('keydown', keyDownHandler);
    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [data]);

  return (
    <>
      <Modal show={show} className="modal-common" onHide={handleClose}>
        <Modal.Header closeButton>Rate & Review</Modal.Header>
        <Modal.Body>
          <form>
            <div className="text-center mb-4">
              {data?.avatar ? (<>
                <img src={`${user?.baseS3Url}${data?.avatar} `} style={{ objectFit: 'cover', width: '45px', borderRadius: '50%', height: '45px' }} alt="" />
              </>) :
                <img src={deafultuserImg} style={{ objectFit: 'cover', width: '45px', borderRadius: '50%', height: '45px' }} alt="" />
              }
              <p className="mt-1  mb-0 fw-bold">{data?.fullName}</p>
            </div>
            <div className="d-flex justify-content-center gap-1">

              <>
                {[...Array(5)].map((item, index) => {
                  const givenRating = index + 1;
                  return (
                    <Form.Check
                      key={givenRating}

                      type="radio"
                      id={`star-${givenRating}`}
                      label={
                        <FaStar
                          color={
                            givenRating <= formik?.values?.rating
                              ? "#e9641f" // Yellow color for selected and previous stars
                              : "rgb(192,192,192)" // Gray color for non-selected stars
                          }
                          required
                        />
                      }
                      checked={givenRating === formik?.values?.rating}
                      onChange={() => {
                        formik.setFieldValue("rating", givenRating);
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.rating}
                      autoComplete="current-rating"
                    />
                  );
                })}
              </>
            </div>
            {formik.touched.rating && formik.errors.rating ? (
              <div className="text-danger">{formik.errors.rating}</div>
            ) : null}


            <div className="mb-30">
              <label >Comment</label>
              <br />
              <div className="textrea-overlay w-100">
              <textarea
                className="form-control"
                id="exampleFormControlTextarea1"
                rows="8"
                name="description"
                // onChange={(e) => setDescription(e.target.value)}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.description}
                autoComplete="current-description"
              ></textarea>
              </div>
              {formik.touched.description && formik.errors.description ? (
                <div className="text-danger">{formik.errors.description}</div>
              ) : null}
            </div>

            <button type="submit"
              onClick={() => {
                setIsLoading(true);
                setTimeout(() => {

                  setIsLoading(false);
                  formik.handleSubmit()
                }, 2000);
              }}
              disabled={isLoading}
              className="btn btn-primary modal-blue-btn text-capitalize w-100 text-white"
            >
              {isLoading ? "Submitting..." : "Submit"}
            </button>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default RatenReview;
